import type { Role } from "../../../shared/mutations.ts";
import type { GmailFeature } from "../../../shared/po-email.ts";
import { resetLocalData } from "./sync.ts";

// PO email --- gmail: whether POs can be emailed from Gmail on this server (and if not, what an admin must set).
// Bills and payments --- wise: whether Wise is connected here and the token's access (never the token), and whether this person may pay.
export type WiseFeature = { enabled: boolean; fake: boolean; env: "live" | "sandbox"; missing: string[]; access: string; canPay: boolean };
// KiCad projects --- kicad: whether a dropped KiCad project is made into its manufacturing files here.
export type Me = {
  id: string;
  email: string;
  name: string;
  role: Role;
  avatar_url: string;
  /** Workstations --- a shared account for a PC (migration 072), signed in with a code from an admin. */
  kind?: "person" | "workstation";
  gmail?: GmailFeature;
  wise?: WiseFeature;
  kicad?: boolean;
};

let current: Me | null = null;

export async function loadMe(): Promise<Me | null> {
  const res = await fetch("/api/me");
  current = res.ok ? ((await res.json()) as Me) : null;
  return current;
}

export const me = () => current;

export async function signOut() {
  // Workstations --- signing back in takes a new code from an admin, so it asks first.
  if (current?.kind === "workstation" && !confirm(`Sign ${current.name || "this workstation"} out? Signing back in takes a new code from an admin.`)) return;
  await fetch("/auth/logout", { method: "POST" });
  await resetLocalData();
  location.assign("/login");
}
